import { useEffect, useState } from "react";

// False where matchMedia is missing (SSR, Jest's jsdom), so a caller renders its narrow layout instead of throwing
export const canMatchMedia = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

/**
 * True while the viewport matches a CSS media query, e.g. `(min-width: 640px)` for Tailwind's `sm`.
 * Reads the query on the first render, not after an effect, so a layout keyed to it never paints the wrong way round first.
 */
export default function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => canMatchMedia() && window.matchMedia(query).matches
  );

  useEffect(() => {
    if (!canMatchMedia()) return;
    const mediaQueryList = window.matchMedia(query);
    const onChange = () => setMatches(mediaQueryList.matches);
    onChange();
    mediaQueryList.addEventListener("change", onChange);
    return () => mediaQueryList.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
